module.exports = __webpack_public_path__ + "img/18.77c1ea66.svg";